module.exports = __webpack_public_path__ + "static/media/xmark.bold.ae9e9ec5.svg";